import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from './ui';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="bg-neutral-50 px-4 py-6 mt-12">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <Text size="sm" className="text-neutral-900 opacity-60 font-mono">
                        © {currentYear} 4RKED. All rights reserved.
                    </Text>
                    <div className="flex gap-6">
                        <Link 
                            to="/terms-of-service" 
                            className="text-neutral-900 hover:opacity-60 transition-opacity font-mono text-sm uppercase tracking-wider"
                        >
                            Terms of Service
                        </Link>
                        <Link 
                            to="/privacy-policy" 
                            className="text-neutral-900 hover:opacity-60 transition-opacity font-mono text-sm uppercase tracking-wider"
                        >
                            Privacy Policy
                        </Link>
                        <Link 
                            to="/dmca-policy" 
                            className="text-neutral-900 hover:opacity-60 transition-opacity font-mono text-sm uppercase tracking-wider"
                        >
                            DMCA Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

